import axios from 'axios';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '@/firebase';

let firebaseToken = null;

onAuthStateChanged(auth, async (user) => {
  firebaseToken = user ? await user.getIdToken() : null;
});

axios.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    firebaseToken = await user.getIdToken();
  }

  if (firebaseToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${firebaseToken}`;

    // Backward-compatibility for endpoints still reading `authorization` as query param.
    config.params = config.params || {};
    if (!config.params.authorization) {
      config.params.authorization = `Bearer ${firebaseToken}`;
    }
  }

  return config;
});
